import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../Assets/css/table_grid.css";
import toast from "react-hot-toast";
import { get } from "../Network/requests";
import { getUrl } from "../Network/urls";
import { tokenExpire } from "../Utils";
import AppContext from "../Store/AppContext";
// import Loader from './UI/Loader';
// import NotSubscribedMessageComponent from './NotSubscribedMessageComponent';
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

function EURecordKeepingRTS22TransactionsComponent({
  productCode,
  regulationCode,
}) {
  const [loading, setLoading] = useState(true);
  const {
    // secretAccessId,
    // secretAccessKey,
    clientDetails,
    handleEncryptOtherParamsOfAPI,
    // encryptedClientValuesObj,
    // inputBucketName,
    handleDecryptResponse,
    handleAPIEncryptValue,
    // handleTextColorOfOutputFiles,
    handleEncryptValue,
    handleDecryptedValue,
  } = useContext(AppContext);
  // const [isProductAccessible, setIsProductAccessible] = useState(false);
  const [rowData, setRowData] = useState([]);
  const rowData1 = [];
  const allowedRegulations = clientDetails.dataAccess[`${productCode}`] ?? [];
  const regulationCodeDefault = allowedRegulations[0] ?? null;
  // const [filesData, setFilesData] = useState({});
  const [columnData, setColumnData] = useState([]); // let gridApi;
  const gridRef = useRef();
  const fType = "";
  // let [regulationCode, setRegulationCode] = useState('R001');
  // let regulationCode = localStorage.getItem('regulationCodeAnalyticsM');
  const navigate = useNavigate();
  // const productCode = "P001";
  // const regulationCode = 'R001';
  // const clientData = JSON.parse(localStorage.getItem("clientDetails"));

  const getGridData = () => {
    const storedFileName = localStorage.getItem("coFileName");
    const fileName = storedFileName === null ? "null" : storedFileName;

    const url = getUrl("get-grid-data");
    const encryptedClientId = handleEncryptValue(clientDetails.clientId);
    const encryptedFName = handleEncryptValue(fileName);
    const encryptedFType = handleEncryptValue(fType);
    const encryptedRegulationCode = handleEncryptValue(regulationCode);
    const encryptedProductCode = handleEncryptValue(productCode);
    // console.log(handleDecryptedValue(encryptedRole), '======',handleDecryptedValue(encryptedClientId));
    // const paramsObj = { productCode, regulationCode };
    // const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
    // console.log(clientDetails);
    const data = {
      client_id: encryptedClientId,
      email_id: clientDetails.email,
      f_name: encryptedFName,
      f_type: encryptedFType,
      product: encryptedProductCode,
      regulation: encryptedRegulationCode,
    };
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    // get(`${url}?client_id=${clientData.clientId}&f_name=${fileName}`, true)
    get(`${url}?regdata=${regdataData}`, true)
      .then((response) => {
        const {
          data: { encryptBody, statusCode, authData },
        } = response;
        setLoading(false);
        let finalArr; // uncomment
        switch (statusCode) {
          case 200:
            // body.data.map((item) => finalArr.push(
            //   item.reduce(
            //     (prev, next, index) => ({
            //       ...prev,
            //       [body.columns[index]]: next,
            //     }),
            //     {},
            //   ),
            // ));
            const iv = authData;
            const idToken = localStorage.getItem("userToken");
            const secretKey = idToken.slice(998, 1030);
            const body = handleDecryptResponse(
              encryptBody.toString(),
              secretKey.toString(),
              iv.toString()
            );
            // console.log(body, '--body');
            body.data.forEach((dataArray) => {
              const rowDataItem = {};
              body.columns.forEach((columnName, columnIndex) => {
                if (columnIndex < dataArray.length) {
                  rowDataItem[columnName] = dataArray[columnIndex];
                } else {
                  rowDataItem[columnName] = "";
                }
              });
              rowData1.push(rowDataItem);
            });
            // console.log(rowData1, 'RowData1');
            setRowData(rowData1);
            // -------------------------------------------
            // setRowData(body.data);
            finalArr = body.columns.map((columnName) => ({
              field: columnName,
            }));
            setColumnData(finalArr);
            // console.log(finalArr, '---finalArr');
            // console.log(body, '---body');
            // setColumnData(body.columns);
            // console.log(rowData, '---rowData');
            // console.log(columnData, '---columnData');
            // toast.success('Successfully fetched files.');
            break;
          case 400:
            // toast.error("Error fetching the files.");
            break;
          default:
          // toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        // setLoading(false);
        // toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        // setIsLoading(false);
      });
  };

  // const regulationCodeHandler = (e) => {
  //   // console.log(e, '--e');
  //   // console.log(e.target.value, '--e.target');
  //   setRegulationCode(e.target.value);
  // };

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      // enableRowGroup: true,
      floatingFilter: true,
      editable: true,
      resizable: true,
    }),
    []
  );

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  useEffect(() => {
    getGridData();
  }, []);

  return (
    <>
      <main className="middle_section dashboard_middle">
        <div className="container">
          <NotSubscribedMessageComponent />
        </div>
      </main>
    </>
  );
}

export default EURecordKeepingRTS22TransactionsComponent;
